/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
import { DehydratedState } from '@tanstack/react-query';
import Plpurl from '@tvg/product-listing-url';
import { createQueryClient } from 'common/api/query-client';
import { rootId } from 'common/config';
import React, { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import App, { AppProps } from './App';
import { Router } from './router/Router';

declare global {
  interface Window {
    _uxa: any;
    cnstrcUserId: any;
    QUBITEXP?: string;

    __product_listing_initial_state__: Omit<AppProps, 'queryClient' | 'plpurl'> & { queryState: DehydratedState };
  }
}

const container = document.getElementById(rootId);
const queryClient = createQueryClient();

if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <Router>
        <App
          {...window.__product_listing_initial_state__}
          plpurl={new Plpurl(`${window.location.pathname}${window.location.search}`)}
          queryClient={queryClient}
        />
      </Router>
    </StrictMode>,
  );
} else {
  console.error('Root Container Not Found');
}

if (import.meta.webpackHot) {
  // eslint-disable-next-line no-console
  import.meta.webpackHot.accept(console.error);
}
